import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  chiefComplaints: [],
  allChiefComplaints: [],
  allByCcChiefComplaints: [],
  totalPages: 0,
  totalRecords: 0,
  chiefComplaint: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_122: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_ChiefComplaints(state, chiefComplaints) {
    state.chiefComplaints = chiefComplaints.items;
    state.totalPages = chiefComplaints.totalPages;
    state.totalRecords = chiefComplaints?.totalRecords ?? 0;
  },
  SET_AllChiefComplaints(state, chiefComplaints) {
    state.allChiefComplaints = chiefComplaints;
  },
  SET_AllByCcChiefComplaints(state, chiefComplaints) {
    state.allByCcChiefComplaints = chiefComplaints;
  },
  SET_ChiefComplaint(state, chiefComplaint) {
    state.chiefComplaint = chiefComplaint;
  },
};
const actions = {
  errorChiefComplaint({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllChiefComplaints({ commit, dispatch, rootState }, isActive = "") {
    return apiClient
      .get('/ChiefComplaints/All' + isActive, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllChiefComplaints', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  getAllByCcChiefComplaint({ commit, dispatch, rootState }, title) {
    return apiClient
      .get('/ChiefComplaints/AllByCc?title=' + title, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllByCcChiefComplaints', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  getChiefComplaintsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, category },
  ) {
    var url = '/ChiefComplaints/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (category !== null && category !== undefined) {
      url += '&category=' + category;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_ChiefComplaints', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  addChiefComplaint({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ChiefComplaints', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  addChiefComplaintQuestion({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ChiefComplaintTriageQuestions', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  getChiefComplaint({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/ChiefComplaints/ById?chiefComplaintId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ChiefComplaint', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  editChiefComplaint({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ChiefComplaints/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
  deleteChiefComplaint({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/ChiefComplaints/Remove?chiefComplaintId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorChiefComplaint', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
